
const axios = require('axios');

const sendInviteCode = async (url) => {
  const apiUrl = window.spconfig?.config.apiUrl;
  const data = {
    urltoken: url
  };
  const urlLink = apiUrl + "/growapi/resendcode";
  return await axios.post(urlLink, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => {
      return response;
    },
      (error) => {
        return error;
      })
}
export default sendInviteCode;